import { Component, computed, inject, input, output } from '@angular/core';

import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import {VisitAddFacade} from '@beautyapp/shared'
import { NzModalModule, NzModalService } from 'ng-zorro-antd/modal';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { AddRealizationComponent } from '../add-realization/add-realization.component';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzEmptyComponent, NzEmptyModule } from 'ng-zorro-antd/empty';
import { rxResource } from '@angular/core/rxjs-interop';

@UntilDestroy()
@Component({
  selector: 'beautyapp-realization-list',
  imports: [
    NzCardModule,
    NzGridModule,
    NzDividerModule,
    NzTagModule,
    NzIconModule,
    NzSpaceModule,
    NzAlertModule,
    NzButtonModule,
    NzModalModule,
    NzPopconfirmModule,
    TranslateModule,
    NzEmptyModule
],
  templateUrl: './realization-list.component.html',
  styleUrl: './realization-list.component.scss'
})
export class RealizationListComponent {
  visitAddFacade = inject(VisitAddFacade);
  modalService = inject(NzModalService);
  translateService = inject(TranslateService);
  notificationService = inject(NzNotificationService);

  visitId = input.required<number>();

  getVisit = output();


  realizationResource = rxResource({
    params: () => ({visitId: this.visitId()}),
    stream: ({params}) => this.visitAddFacade.getRealizations(params.visitId)
  })

  realizations = computed(() => this.realizationResource.value())

  addRealization(realization?: any) {
    console.log(realization);
    this.modalService.create({
      nzClosable: true,
      nzMaskClosable: false,
      nzTitle: 'რეალიზაცია',
      nzContent: AddRealizationComponent,
      nzClassName: 'add-realization-modal',
      nzFooter: null,
      nzData: {
        visitId: +this.visitId(),
        realization: realization
      }
    }).afterClose.pipe(
      untilDestroyed(this)
    ).subscribe(() => {
      this.getVisit.emit();
      this.realizationResource.reload();
    });

  }

  deleteRealization(realization: any) {
    this.visitAddFacade.deleteRealization(realization.id)
      .pipe(
        untilDestroyed(this)
      )
      .subscribe(() => {
        this.getVisit.emit();
        this.realizationResource.reload();
      });
  }
}
